import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Loader from './components/dashboard/Loader/Loader';

import AppContainer from './components/common/AppContainer';
import pageRoutes from './pageRoute';
import { useFeatures } from './contexts/FeaturesContext';

const AppRoutes = (props) => {
  const { user, isFeaturesLoading } = useFeatures();
  return (
    <React.Suspense fallback={<Loader />}>
      <Routes>
        {pageRoutes?.map((route) => {
          const Component = route.component;
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppContainer {...props} {...route} user={user} isFeaturesLoading={isFeaturesLoading} >
                  <Component {...props} {...route} user={user} />
                </AppContainer>
              }
            />
          );
        })}
      </Routes>
    </React.Suspense>
  );
};

export default AppRoutes;
